// import { IText } from "fabric/fabric-impl";
import moment from "jalali-moment";
import React from "react";

class CheckInCheckOut extends React.Component {

    state = {
        time: null,
        checkOutTime: null,
        diff: '',
        btn: false
    }
    componentDidMount() {

    }
    setTime = () => {
        let time = this.state.time
        this.setState({ time: time + 1 }, () => {
        })
    }
    checkin = () => {
        // console.log('checkin')
        // let newTime = new Date()
        // console.log(typeof newTime)
        // this.setState({ time: newTime, btn: !this.state.btn })
        let now = new Date().valueOf()
        this.setState({ btn: true })
        this.setState({ time: now }, () => {

            setInterval(() => {
                this.setTime()
            }, 1000);
        })

    }

    // checkout = () => {
    //     console.log('checkout')
    //     if (this.state.checkOutTime == null) {
    //         console.log('checkin')
    //         let checkOutTime = this.state.checkOutTime
    //         let newTime = new Date().toLocaleString()
    //         console.log(typeof newTime)
    //         this.setState({ checkOutTime: newTime }, () => {

    //             let diff = (new Date(this.state.checkOutTime).valueOf() - new Date(this.state.time).valueOf()) / 1000

    //             console.log('diff', (diff / 3600000))
    //             // this.setState({ diff, time: null, checkOutTime: null })
    //             this.setState({ diff })
    //         })
    //     } else {
    //         alert('fahmidim tamoom shod')
    //     }
    // }
    render() {
        return (

            <div className="dashboard-widgets p-3">
                <p className="pb-3" style={{ fontSize: 15, fontWeight: '500' }}>Log Time</p>
                <div className='' style={{ height: '100%', maxHeight: '400px', overflow: 'auto' }}>
                    <div className="cursor-pointer" onClick={() => this.checkin()}>
                        <div className="flexc p-2" style={this.state.btn ? { background: 'red', color: 'white', borderRadius: '10px', width: '65%' } : { background: 'green', color: 'white', borderRadius: '10px', width: '53%' }} >
                            {/* <img width={'50px'} src={this.state.btn ? '/images/icons/timer.png' : '/images/icons/timer.png'} alt="" /> */}

                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" style={{ width: 35 }}>
                                <path strokeLinecap="round" strokeLinejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>

                            <div className="mld-4">
                                <button style={{ fontSize: '14px', fontWeight: 600 }} className="w-100 color-white text-left" >{this.state.btn ? 'Check Out' : 'Check In'}</button>
                                {/* {this.state.time != null && ( */}
                                <p className="" style={{ color: 'white', fontSize: '14px', fontWeight: 600 }}>{this.state.time == null ? '00:00:00' : moment(this.state.time).toISOString()}</p>
                                {/* )} */}
                            </div>
                        </div>
                    </div>

                </div>
            </div >
        )
    }
}


export default CheckInCheckOut;